/**
 * Key / Value pair to translate API keys to better named, camelCased keys.
 * Any keys included in the request / response will be and not mapped here
 * will be removed.
 *
 * @var {Object} brandMap
 */
var brandMap = {
  colour: 'colour',
  commission: 'commission',
  consolidated: 'consolidated',
  created_at: 'createdAt',
  default_location_description_markdown: 'defaultLocationDescriptionMarkdown',
  deleted_at: 'deletedAt',
  description: 'description',
  email: 'emailAddress',
  expiry: 'expiry',
  faq: 'faq',
  id: 'id',
  integration_id: 'integrationId',
  location_text: 'locationCopy',
  logo: 'logoFilename',
  logo_url: 'logoUrl',
  map_pin_url: 'mapPinUrl',
  name: 'name',
  products: 'products',
  redeem: 'redeem',
  share: 'shareCopy',
  stores: 'stores',
  success: 'successCopy',
  updated_at: 'updatedAt',
  user_id: 'userId',
  vat: 'vat',
  website: 'websiteUrl',
  weight: 'weight'
};
export default brandMap;